import React from "react";
import serengeti1 from "../assets/serengeti1.jpg";
import nairobi from "../assets/nairobi.jpg";
import kenya from "../assets/kenya.jpg";
import image17 from "../assets/image17.jpg";
import team from "../assets/team.jpg";

import {
  ArrowRight,
  CalendarCheck,
  Check,
  MessageCircle,
  Phone,
  ShieldCheck,
  Plane,
  FileText,
  GraduationCap,
  Hotel,
  Globe,
  MapPin,
  Briefcase,
} from "lucide-react";

const Services = () => {
  const images = {
    hero:
      "https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=1800&q=85",

    safari:
      "https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=1400&q=85",

    nairobiNationalPark:
      "https://images.unsplash.com/photo-1634662101368-fa8021773862?auto=format&fit=crop&w=1400&q=85",

    giraffeCentre:
      "https://static.wixstatic.com/media/163cb6_0433244089a747df9fb8dba4b8ab74a2~mv2_d_2000_1333_s_2.jpg/v1/fill/w_1600,h_1066,al_c/163cb6_0433244089a747df9fb8dba4b8ab74a2~mv2_d_2000_1333_s_2.jpg",

    campNdunda:
      "https://zazuventure.com/wp-content/uploads/2023/06/1c.jpg",

    teamBuilding:
      "https://kambimstuniresort.com/images/team-building-in-kenya.jpg",

    hotel:
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=1600&q=90",

    airport:
      "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=1400&q=85",

    beach:
      "https://images.unsplash.com/photo-1505881502353-a1986add3762?auto=format&fit=crop&w=1400&q=85",

    travelPlanning:
      "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1400&q=85",

    ticketing:
      "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=1600&q=90",

    visa:
      "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=1600&q=90",

    passport:
      "https://images.unsplash.com/photo-1521791055366-0d553872125f?auto=format&fit=crop&w=1600&q=90",

    student:
      "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=1600&q=90",

    international:
      "https://images.unsplash.com/photo-1500534623283-312aade485b7?auto=format&fit=crop&w=1600&q=90",

    dubai:
      "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1600&q=90",

    zanzibar:
      "https://images.unsplash.com/photo-1586861635167-e5223aadc9fe?auto=format&fit=crop&w=1600&q=90",

    mombasa:
      "https://images.unsplash.com/photo-1590845947676-fa2576f401d2?auto=format&fit=crop&w=1600&q=90",
  };

  const services = [
    {
      number: "01",
      title: "Tours & Safaris",
      category: "Wildlife & Adventure",
      description:
        "Discover Kenya and East Africa through carefully planned wildlife safaris, private tours, group adventures and tailor-made journeys.",
      image: kenya,
      features: [
        "Maasai Mara safaris",
        "Wildlife experiences",
        "Private & group tours",
        "Custom itineraries",
      ],
    },
    {
      number: "02",
      title: "Flight Ticketing",
      category: "Domestic & International",
      description:
        "Book convenient domestic and international flights with itinerary support for holidays, business travel, students, families and groups.",
      image: images.ticketing,
      features: [
        "Domestic flights",
        "International flights",
        "One-way & return tickets",
        "Multi-city itineraries",
      ],
    },
    {
      number: "03",
      title: "Visa Assistance",
      category: "Travel Documentation",
      description:
        "Get practical assistance preparing your visa application requirements and organizing the documentation needed for your intended destination.",
      image: images.visa,
      features: [
        "Visa application guidance",
        "Document checklist support",
        "Application preparation",
        "Travel requirement guidance",
      ],
    },
    {
      number: "04",
      title: "Passport Services",
      category: "Documentation Support",
      description:
        "Receive guidance on passport application and processing requirements so you can prepare your travel documents correctly.",
      image: images.passport,
      features: [
        "Passport application guidance",
        "Document preparation",
        "Application information",
        "Travel document support",
      ],
    },
    {
      number: "05",
      title: "Hotel Bookings",
      category: "Accommodation",
      description:
        "Find suitable hotels, safari lodges, camps and beach resorts according to your destination, travel style, group size and budget.",
      image: images.hotel,
      features: [
        "Hotels & lodges",
        "Safari camps",
        "Beach resorts",
        "Accommodation planning",
      ],
    },
    {
      number: "06",
      title: "Student Travel",
      category: "Students & Young Travellers",
      description:
        "Travel planning support for students looking for study-related travel, internships, educational trips and international opportunities.",
      image: images.student,
      features: [
        "Student travel planning",
        "Study-related travel",
        "Internship travel support",
        "Flight & accommodation guidance",
      ],
    },
    {
      number: "07",
      title: "Airport Transfers",
      category: "Transport",
      description:
        "Start and end your journey comfortably with reliable airport transfers between Nairobi airports, hotels and other destinations.",
      image: images.airport,
      features: [
        "Airport pickups",
        "Airport drop-offs",
        "Private transfers",
        "Professional service",
      ],
    },
    {
      number: "08",
      title: "Car Hire",
      category: "Vehicle Services",
      description:
        "Choose convenient vehicle solutions for business, leisure, road trips, airport transfers and exploring Kenya at your own pace.",
      image: serengeti1,
      features: [
        "Flexible vehicle options",
        "Short & long-term hire",
        "Self-drive options",
        "Chauffeur services",
      ],
    },
    {
      number: "09",
      title: "International Travel",
      category: "Global Travel",
      description:
        "Plan journeys beyond Kenya with assistance covering flights, accommodation, documentation, destination planning and travel coordination.",
      image: images.international,
      features: [
        "International destinations",
        "Travel planning",
        "Flights & accommodation",
        "Documentation guidance",
      ],
    },
    {
      number: "10",
      title: "Beach Holidays",
      category: "Coastal Escapes",
      description:
        "Enjoy memorable coastal holidays with accommodation, transport, excursions and carefully arranged beach experiences.",
      image: images.beach,
      features: [
        "Mombasa",
        "Diani Beach",
        "Zanzibar",
        "Coastal excursions",
      ],
    },
    {
      number: "11",
      title: "Nairobi Excursions",
      category: "Local Experiences",
      description:
        "Explore Nairobi's wildlife and attractions through flexible day trips and professionally coordinated excursions.",
      image: images.nairobiNationalPark,
      features: [
        "Nairobi National Park",
        "Giraffe Centre",
        "City excursions",
        "Private & group trips",
      ],
    },
    {
      number: "12",
      title: "Team Building",
      category: "Corporate & Groups",
      description:
        "Take your team outside the office with coordinated team-building activities, transport, accommodation and group experiences.",
      image: team,
      features: [
        "Corporate outings",
        "Team activities",
        "Group transport",
        "Trip coordination",
      ],
    },
  ];

  const internationalDestinations = [
    {
      title: "Dubai",
      category: "International Escape",
      image: images.dubai,
      description:
        "Plan an exciting Dubai journey combining flights, accommodation, city experiences and travel coordination.",
      points: [
        "Flight booking",
        "Hotel arrangements",
        "Travel planning",
        "City experiences",
      ],
    },
    {
      title: "Zanzibar",
      category: "Island Holiday",
      image: images.zanzibar,
      description:
        "Experience the beaches, culture and tropical atmosphere of Zanzibar with a coordinated holiday package.",
      points: [
        "Beach holidays",
        "Hotels & resorts",
        "Flight arrangements",
        "Island experiences",
      ],
    },
    {
      title: "Mombasa",
      category: "Kenya Coast",
      image: images.mombasa,
      description:
        "Enjoy Kenya's coast through beach holidays, hotel stays, excursions, transfers and customized travel plans.",
      points: [
        "Beach resorts",
        "Hotel bookings",
        "Coastal excursions",
        "Airport transfers",
      ],
    },
  ];

  const benefits = [
    {
      number: "01",
      title: "One Travel Partner",
      text:
        "Bring your flights, accommodation, documentation, transport and experiences together through one travel team.",
    },
    {
      number: "02",
      title: "Local Knowledge",
      text:
        "Our understanding of Kenya helps you discover destinations and experiences suited to your trip.",
    },
    {
      number: "03",
      title: "Flexible Planning",
      text:
        "Your arrangements can be shaped around your schedule, interests, group size and travel requirements.",
    },
    {
      number: "04",
      title: "Personal Support",
      text:
        "From your first enquiry to your journey, our team remains available to help coordinate your travel.",
    },
  ];

  const process = [
    {
      number: "01",
      title: "Tell Us Your Plans",
      text:
        "Share your destination, dates, interests, documents or travel requirements with our team.",
    },
    {
      number: "02",
      title: "We Organize",
      text:
        "We help coordinate flights, accommodation, transport, experiences and other travel arrangements.",
    },
    {
      number: "03",
      title: "Travel With Confidence",
      text:
        "Receive your arrangements and travel with the support of a dedicated travel partner.",
    },
  ];

  const documentation = [
    "Visa application guidance",
    "Passport processing guidance",
    "Travel document checklists",
    "Destination requirement guidance",
    "Flight and accommodation coordination",
    "General pre-travel preparation",
  ];

  const studentServices = [
    "Student flight ticketing",
    "Study-related travel planning",
    "Internship travel support",
    "Accommodation guidance",
    "Airport transfer arrangements",
    "Travel document guidance",
  ];

  return (
    <main className="bg-white text-[#17151A]">
      {/* =====================================================
          HERO
      ===================================================== */}
      <section className="relative min-h-[72vh] overflow-hidden bg-[#17151A]">
        <img
          src={image17}
          alt="Wincate Tours and Travels"
          className="absolute inset-0 h-full w-full object-cover"
        />

        <div className="absolute inset-0 bg-gradient-to-r from-[#17151A]/95 via-[#17151A]/70 to-[#17151A]/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#17151A]/95 via-transparent to-transparent" />

        <div className="relative mx-auto flex min-h-[72vh] max-w-7xl items-end px-6 pb-16 pt-32 sm:px-8 lg:px-10">
          <div className="max-w-4xl">
            <div className="mb-5 flex items-center gap-3">
              <span className="h-[2px] w-10 bg-[#EC1676]" />
              <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#FF72AC]">
                Wincate Tours & Travels
              </span>
            </div>

            <h1 className="font-serif text-5xl font-bold leading-[1.02] text-white sm:text-6xl lg:text-7xl">
              Everything You Need
              <br />
              <span className="text-[#FF72AC]">To Travel Further.</span>
            </h1>

            <p className="mt-6 max-w-2xl text-base leading-8 text-white/75 sm:text-lg">
              From safaris and local excursions to visa assistance, passport
              support, flight ticketing, hotel bookings, student travel and
              international journeys, Wincate helps bring your travel plans
              together.
            </p>

            <div className="mt-8 flex flex-col gap-4 sm:flex-row">
              <a
                href="/contact"
                className="inline-flex items-center justify-center gap-3 rounded-full bg-[#EC1676] px-7 py-4 text-sm font-bold text-white transition hover:-translate-y-1 hover:bg-[#D80F68] hover:shadow-2xl"
              >
                Start Planning
                <ArrowRight size={17} />
              </a>

              <a
                href="https://wa.me/254724938419"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center gap-3 rounded-full border border-white/20 bg-white/10 px-7 py-4 text-sm font-bold text-white backdrop-blur-md transition hover:-translate-y-1 hover:bg-white hover:text-[#17151A]"
              >
                <MessageCircle size={18} />
                WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          SERVICE PILLARS
      ===================================================== */}
      <section className="border-b border-gray-100 bg-white py-7">
        <div className="mx-auto grid max-w-7xl grid-cols-2 gap-3 px-6 sm:grid-cols-3 lg:grid-cols-6 lg:px-10">
          {[
            {
              icon: Plane,
              title: "Ticketing",
            },
            {
              icon: FileText,
              title: "Visa Support",
            },
            {
              icon: Briefcase,
              title: "Passport",
            },
            {
              icon: Hotel,
              title: "Hotels",
            },
            {
              icon: GraduationCap,
              title: "Student Travel",
            },
            {
              icon: Globe,
              title: "International",
            },
          ].map((item) => {
            const Icon = item.icon;

            return (
              <a
                href="/contact"
                key={item.title}
                className="group flex items-center gap-3 rounded-2xl bg-[#FFF9F5] p-4 transition hover:-translate-y-1 hover:bg-[#EC1676]"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#EC1676]/10 text-[#EC1676] transition group-hover:bg-white/20 group-hover:text-white">
                  <Icon size={18} />
                </span>

                <span className="text-xs font-bold text-[#17151A] group-hover:text-white">
                  {item.title}
                </span>
              </a>
            );
          })}
        </div>
      </section>

      {/* =====================================================
          INTRO
      ===================================================== */}
      <section className="relative overflow-hidden bg-[#FFF9F5] py-20 sm:py-24">
        <div className="absolute -right-32 top-0 h-80 w-80 rounded-full bg-[#EC1676]/10 blur-3xl" />

        <div className="relative mx-auto max-w-7xl px-6 sm:px-8 lg:px-10">
          <div className="mx-auto max-w-4xl text-center">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#EC1676]">
              Complete Travel Solutions
            </span>

            <h2 className="mt-4 font-serif text-4xl font-bold leading-tight sm:text-5xl lg:text-6xl">
              More Than Just
              <span className="text-[#EC1676]"> Travel</span>
            </h2>

            <p className="mt-6 text-base leading-8 text-gray-600 sm:text-lg">
              Whether you are planning a safari, booking a flight, applying
              for a visa, processing a passport, arranging accommodation,
              planning a student journey or travelling internationally,
              Wincate Tours & Travels provides practical travel support from
              planning to departure.
            </p>
          </div>
        </div>
      </section>

      {/* =====================================================
          MAIN SERVICES
      ===================================================== */}
      <section className="bg-white py-20 sm:py-24 lg:py-28">
        <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-10">
          <div className="mb-14 flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
            <div className="max-w-3xl">
              <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#EC1676]">
                What We Offer
              </span>

              <h2 className="mt-4 font-serif text-4xl font-bold leading-tight sm:text-5xl">
                Travel Services
                <span className="text-[#EC1676]"> Built Around You</span>
              </h2>
            </div>

            <p className="max-w-xl text-sm leading-7 text-gray-500">
              From travel documents and flights to safaris, accommodation,
              transport and international travel, explore our core services.
            </p>
          </div>

          <div className="grid gap-7 md:grid-cols-2 lg:grid-cols-3">
            {services.map((service) => (
              <article
                key={service.number}
                className="group overflow-hidden rounded-[2rem] border border-gray-100 bg-white shadow-sm transition duration-500 hover:-translate-y-2 hover:shadow-2xl"
              >
                <div className="relative h-[300px] overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    loading="lazy"
                    className="h-full w-full object-cover transition duration-700 group-hover:scale-110"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-[#17151A]/95 via-[#17151A]/20 to-transparent" />

                  <div className="absolute left-5 top-5 flex h-11 w-11 items-center justify-center rounded-full bg-[#EC1676] text-sm font-black text-white shadow-xl">
                    {service.number}
                  </div>

                  <div className="absolute bottom-5 left-6 right-6">
                    <span className="rounded-full bg-white/15 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.18em] text-white backdrop-blur-md">
                      {service.category}
                    </span>

                    <h3 className="mt-3 font-serif text-2xl font-bold text-white">
                      {service.title}
                    </h3>
                  </div>
                </div>

                <div className="p-7">
                  <p className="text-sm leading-7 text-gray-600">
                    {service.description}
                  </p>

                  <div className="mt-6 space-y-3">
                    {service.features.map((feature) => (
                      <div
                        key={feature}
                        className="flex items-center gap-3"
                      >
                        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#EC1676]/10">
                          <Check
                            size={13}
                            className="text-[#EC1676]"
                          />
                        </span>

                        <span className="text-sm font-semibold text-gray-700">
                          {feature}
                        </span>
                      </div>
                    ))}
                  </div>

                  <a
                    href="/contact"
                    className="mt-7 inline-flex items-center gap-2 text-sm font-bold text-[#EC1676] transition-all group-hover:gap-3"
                  >
                    Enquire Now
                    <ArrowRight size={16} />
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* =====================================================
          VISA + PASSPORT
      ===================================================== */}
      <section className="bg-[#17151A] py-20 sm:py-24 lg:py-28">
        <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-10">
          <div className="grid items-center gap-12 lg:grid-cols-2">
            <div className="relative overflow-hidden rounded-[2.5rem]">
              <img
                src={images.visa}
                alt="Visa application and travel documentation"
                loading="lazy"
                className="h-[520px] w-full object-cover transition duration-700 hover:scale-105"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-[#17151A]/90 via-[#17151A]/10 to-transparent" />

              <div className="absolute bottom-7 left-7 right-7">
                <div className="rounded-2xl border border-white/20 bg-black/25 p-5 backdrop-blur-md">
                  <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#FF72AC]">
                    Travel Documentation
                  </p>

                  <p className="mt-2 font-serif text-2xl font-bold text-white">
                    Prepare Your Documents With Confidence
                  </p>
                </div>
              </div>
            </div>

            <div>
              <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#FF72AC]">
                Visa & Passport Support
              </span>

              <h2 className="mt-4 font-serif text-4xl font-bold leading-tight text-white sm:text-5xl">
                Your Documents.
                <br />
                <span className="text-[#FF72AC]">
                  Your Journey.
                </span>
              </h2>

              <p className="mt-6 text-base leading-8 text-white/60">
                Preparing to travel internationally? Wincate can help you
                understand the documentation and application requirements
                associated with your intended destination.
              </p>

              <div className="mt-8 grid gap-3 sm:grid-cols-2">
                {documentation.map((item) => (
                  <div
                    key={item}
                    className="flex items-center gap-3 rounded-2xl border border-white/10 bg-white/[0.04] p-4"
                  >
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#EC1676] text-white">
                      <Check size={14} />
                    </span>

                    <span className="text-sm font-semibold text-white/80">
                      {item}
                    </span>
                  </div>
                ))}
              </div>

              <div className="mt-8 rounded-2xl border border-[#EC1676]/30 bg-[#EC1676]/10 p-5">
                <p className="text-xs leading-6 text-white/60">
                  <strong className="text-white">
                    Important:
                  </strong>{" "}
                  Visa and passport approvals are determined by the relevant
                  government, embassy, immigration or passport authority.
                  Wincate provides travel guidance and application support but
                  cannot guarantee approval.
                </p>
              </div>

              <a
                href="/contact"
                className="mt-8 inline-flex items-center gap-3 rounded-full bg-[#EC1676] px-7 py-4 text-sm font-bold text-white transition hover:-translate-y-1 hover:bg-[#D80F68]"
              >
                Get Documentation Support
                <ArrowRight size={17} />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          FLIGHT TICKETING
      ===================================================== */}
      <section className="bg-[#FFF9F5] py-20 sm:py-24 lg:py-28">
        <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-10">
          <div className="grid overflow-hidden rounded-[2.5rem] bg-white shadow-xl lg:grid-cols-2">
            <div className="relative min-h-[500px]">
              <img
                src={images.ticketing}
                alt="Flight ticketing service"
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-[#17151A]/80 via-transparent to-transparent" />

              <div className="absolute bottom-7 left-7">
                <span className="rounded-full bg-[#EC1676] px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] text-white">
                  Flight Ticketing
                </span>
              </div>
            </div>

            <div className="flex items-center p-8 sm:p-12 lg:p-16">
              <div>
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#EC1676]/10">
                  <Plane size={25} className="text-[#EC1676]" />
                </div>

                <span className="mt-7 block text-xs font-bold uppercase tracking-[0.25em] text-[#EC1676]">
                  Fly With Ease
                </span>

                <h2 className="mt-3 font-serif text-4xl font-bold leading-tight sm:text-5xl">
                  Flight Booking
                  <span className="text-[#EC1676]">
                    {" "}
                    Made Simple.
                  </span>
                </h2>

                <p className="mt-6 text-base leading-8 text-gray-600">
                  Whether you are travelling for business, study, family,
                  leisure or adventure, we can help you organize flight
                  arrangements around your itinerary.
                </p>

                <div className="mt-8 grid gap-3 sm:grid-cols-2">
                  {[
                    "Domestic flights",
                    "International flights",
                    "One-way & return",
                    "Multi-city travel",
                    "Group bookings",
                    "Student travel",
                  ].map((item) => (
                    <div
                      key={item}
                      className="flex items-center gap-3 rounded-xl bg-[#FFF9F5] px-4 py-3"
                    >
                      <Check
                        size={16}
                        className="shrink-0 text-[#EC1676]"
                      />

                      <span className="text-sm font-semibold text-gray-700">
                        {item}
                      </span>
                    </div>
                  ))}
                </div>

                <a
                  href="/contact"
                  className="mt-8 inline-flex items-center gap-3 rounded-full bg-[#17151A] px-7 py-4 text-sm font-bold text-white transition hover:-translate-y-1 hover:bg-black"
                >
                  Request Flight Booking
                  <ArrowRight size={17} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          STUDENT TRAVEL
      ===================================================== */}
      <section className="bg-white py-20 sm:py-24 lg:py-28">
        <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-10">
          <div className="grid items-center gap-12 lg:grid-cols-2">
            <div>
              <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#EC1676]">
                Students & Young Travellers
              </span>

              <h2 className="mt-4 font-serif text-4xl font-bold leading-tight sm:text-5xl">
                Your Next Chapter
                <br />
                <span className="text-[#EC1676]">
                  Starts Somewhere.
                </span>
              </h2>

              <p className="mt-6 text-base leading-8 text-gray-600">
                Wincate provides travel planning support for students and
                young travellers preparing for study-related journeys,
                internships, educational travel and international experiences.
              </p>

              <div className="mt-8 space-y-4">
                {studentServices.map((item) => (
                  <div
                    key={item}
                    className="flex items-center gap-3"
                  >
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#EC1676] text-white">
                      <Check size={14} />
                    </span>

                    <span className="text-sm font-semibold text-gray-700">
                      {item}
                    </span>
                  </div>
                ))}
              </div>

              <div className="mt-8 rounded-2xl border border-[#EC1676]/20 bg-[#FFF9F5] p-5">
                <p className="text-sm leading-7 text-gray-600">
                  If you are looking for an actual job or internship placement,
                  eligibility and placement depend on the relevant employer,
                  institution or program. Our role is to assist with travel
                  planning and related arrangements.
                </p>
              </div>

              <a
                href="/contact"
                className="mt-8 inline-flex items-center gap-3 rounded-full bg-[#EC1676] px-7 py-4 text-sm font-bold text-white transition hover:-translate-y-1 hover:bg-[#D80F68]"
              >
                Plan Student Travel
                <ArrowRight size={17} />
              </a>
            </div>

            <div className="relative overflow-hidden rounded-[2.5rem]">
              <img
                src={images.student}
                alt="Students travelling together"
                loading="lazy"
                className="h-[560px] w-full object-cover transition duration-700 hover:scale-105"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-[#17151A]/80 via-transparent to-transparent" />

              <div className="absolute bottom-7 left-7 right-7">
                <div className="rounded-2xl border border-white/20 bg-black/25 p-6 backdrop-blur-md">
                  <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#FF72AC]">
                    Student Travel
                  </p>

                  <h3 className="mt-2 font-serif text-2xl font-bold text-white">
                    Study. Explore. Experience.
                  </h3>

                  <p className="mt-2 text-sm leading-6 text-white/60">
                    Practical support for your journey beyond the classroom.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          INTERNATIONAL TRAVEL
      ===================================================== */}
      <section className="bg-[#17151A] py-20 sm:py-24 lg:py-28">
        <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-10">
          <div className="mx-auto max-w-3xl text-center">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#FF72AC]">
              Local & International
            </span>

            <h2 className="mt-4 font-serif text-4xl font-bold text-white sm:text-5xl">
              Go Further With
              <span className="text-[#FF72AC]">
                {" "}
                Wincate
              </span>
            </h2>

            <p className="mt-5 text-base leading-8 text-white/55">
              From Kenya's coast to international destinations, we help
              coordinate the essential parts of your journey.
            </p>
          </div>

          <div className="mt-14 grid gap-7 md:grid-cols-3">
            {internationalDestinations.map((destination) => (
              <article
                key={destination.title}
                className="group overflow-hidden rounded-[2rem] border border-white/10 bg-white/[0.04] transition duration-500 hover:-translate-y-2 hover:bg-white/[0.07]"
              >
                <div className="relative h-[300px] overflow-hidden">
                  <img
                    src={destination.image}
                    alt={destination.title}
                    loading="lazy"
                    className="h-full w-full object-cover transition duration-700 group-hover:scale-110"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-[#17151A] via-transparent to-transparent" />

                  <div className="absolute bottom-6 left-6">
                    <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#FF72AC]">
                      {destination.category}
                    </span>

                    <h3 className="mt-2 font-serif text-3xl font-bold text-white">
                      {destination.title}
                    </h3>
                  </div>
                </div>

                <div className="p-7">
                  <p className="text-sm leading-7 text-white/55">
                    {destination.description}
                  </p>

                  <div className="mt-6 space-y-3">
                    {destination.points.map((point) => (
                      <div
                        key={point}
                        className="flex items-center gap-3"
                      >
                        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#EC1676]/20">
                          <Check
                            size={13}
                            className="text-[#FF72AC]"
                          />
                        </span>

                        <span className="text-sm font-semibold text-white/75">
                          {point}
                        </span>
                      </div>
                    ))}
                  </div>

                  <a
                    href="/contact"
                    className="mt-7 inline-flex items-center gap-2 text-sm font-bold text-[#FF72AC] transition-all group-hover:gap-3"
                  >
                    Plan This Journey
                    <ArrowRight size={16} />
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* =====================================================
          NAIROBI EXPERIENCES
      ===================================================== */}
      <section className="bg-[#FFF9F5] py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-10">
          <div className="grid overflow-hidden rounded-[2.5rem] bg-[#17151A] lg:grid-cols-2">
            <div className="relative min-h-[500px]">
              <img
                src={nairobi}
                alt="Nairobi wildlife experience"
                className="absolute inset-0 h-full w-full object-cover"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-[#17151A]/85 via-transparent to-transparent" />

              <div className="absolute bottom-7 left-7">
                <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#FF72AC]">
                  Nairobi Experiences
                </span>

                <h3 className="mt-2 font-serif text-3xl font-bold text-white sm:text-4xl">
                  Wildlife Just Outside the City
                </h3>
              </div>
            </div>

            <div className="flex items-center px-7 py-14 sm:px-12 lg:px-16">
              <div>
                <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#FF72AC]">
                  Discover Nairobi
                </span>

                <h2 className="mt-4 font-serif text-4xl font-bold leading-tight text-white sm:text-5xl">
                  Your Nairobi
                  <span className="text-[#FF72AC]">
                    {" "}
                    Adventure
                  </span>
                </h2>

                <p className="mt-6 text-base leading-8 text-white/60">
                  Explore some of Nairobi's most popular attractions through
                  flexible day trips, private excursions and group travel.
                </p>

                <div className="mt-8 grid gap-4 sm:grid-cols-2">
                  <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-5">
                    <MapPin className="text-[#FF72AC]" size={22} />

                    <h4 className="mt-4 font-serif text-lg font-bold text-white">
                      Nairobi National Park
                    </h4>

                    <p className="mt-2 text-sm leading-6 text-white/50">
                      Wildlife experiences close to the city.
                    </p>
                  </div>

                  <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-5">
                    <MapPin className="text-[#FF72AC]" size={22} />

                    <h4 className="mt-4 font-serif text-lg font-bold text-white">
                      Giraffe Centre
                    </h4>

                    <p className="mt-2 text-sm leading-6 text-white/50">
                      A memorable wildlife experience for visitors of all
                      ages.
                    </p>
                  </div>
                </div>

                <a
                  href="/contact"
                  className="mt-8 inline-flex items-center gap-3 rounded-full bg-[#EC1676] px-7 py-4 text-sm font-bold text-white transition hover:-translate-y-1 hover:bg-[#D80F68]"
                >
                  Book an Excursion
                  <ArrowRight size={17} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          CAMP NDUNDA
      ===================================================== */}
      <section className="relative overflow-hidden bg-white py-20 sm:py-24">
        <div className="absolute -right-40 top-0 h-96 w-96 rounded-full bg-[#EC1676]/10 blur-3xl" />

        <div className="relative mx-auto max-w-7xl px-6 sm:px-8 lg:px-10">
          <div className="grid items-center gap-12 lg:grid-cols-2">
            <div>
              <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#EC1676]">
                Nature & Adventure
              </span>

              <h2 className="mt-4 font-serif text-4xl font-bold leading-tight sm:text-5xl">
                Escape to
                <span className="text-[#EC1676]">
                  {" "}
                  Camp Ndunda
                </span>
              </h2>

              <p className="mt-6 max-w-xl text-base leading-8 text-gray-600">
                Looking for something different from the traditional safari?
                Add a nature and outdoor adventure experience to your travel
                plans and enjoy a refreshing escape with friends, family or
                colleagues.
              </p>

              <div className="mt-8 flex flex-wrap gap-3">
                {[
                  "Nature",
                  "Adventure",
                  "Outdoor Activities",
                  "Groups",
                  "Team Experiences",
                ].map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full border border-[#EC1676]/10 bg-[#FFF9F5] px-4 py-2 text-xs font-bold text-gray-700"
                  >
                    {tag}
                  </span>
                ))}
              </div>

              <a
                href="/contact"
                className="mt-9 inline-flex items-center gap-3 rounded-full bg-[#17151A] px-7 py-4 text-sm font-bold text-white transition hover:-translate-y-1 hover:bg-black"
              >
                Plan the Experience
                <ArrowRight size={17} />
              </a>
            </div>

            <div className="relative">
              <img
                src={images.campNdunda}
                alt="Camp Ndunda Kenya"
                loading="lazy"
                className="h-[480px] w-full rounded-[2.5rem] object-cover"
              />

              <div className="absolute -bottom-5 left-5 rounded-2xl bg-[#EC1676] px-6 py-5 shadow-2xl sm:left-6">
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-white/70">
                  Experience Kenya
                </p>

                <p className="mt-1 font-serif text-xl font-bold text-white">
                  Nature. Adventure. Memories.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          TEAM BUILDING
      ===================================================== */}
      <section className="bg-[#FFF9F5] py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-10">
          <div className="grid items-center gap-12 lg:grid-cols-2">
            <div className="order-2 lg:order-1">
              <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#EC1676]">
                Corporate & Groups
              </span>

              <h2 className="mt-4 font-serif text-4xl font-bold leading-tight sm:text-5xl">
                Bring Your
                <span className="text-[#EC1676]">
                  {" "}
                  Team Together
                </span>
              </h2>

              <p className="mt-6 text-base leading-8 text-gray-600">
                Take your team outside the office and create meaningful
                experiences through carefully coordinated team-building
                activities, excursions, transport and accommodation.
              </p>

              <div className="mt-8 space-y-4">
                {[
                  "Corporate team-building trips",
                  "Group transport arrangements",
                  "Outdoor activities and excursions",
                  "Accommodation coordination",
                ].map((item) => (
                  <div
                    key={item}
                    className="flex items-center gap-3"
                  >
                    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#EC1676] text-white">
                      <Check size={14} />
                    </span>

                    <span className="text-sm font-semibold text-gray-700">
                      {item}
                    </span>
                  </div>
                ))}
              </div>

              <a
                href="/contact"
                className="mt-9 inline-flex items-center gap-3 rounded-full bg-[#17151A] px-7 py-4 text-sm font-bold text-white transition hover:-translate-y-1 hover:bg-black"
              >
                Plan Team Building
                <ArrowRight size={17} />
              </a>
            </div>

            <div className="order-1 lg:order-2">
              <div className="relative overflow-hidden rounded-[2.5rem]">
                <img
                  src={team}
                  alt="Team building activity in Kenya"
                  loading="lazy"
                  className="h-[500px] w-full object-cover transition duration-700 hover:scale-105"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-[#17151A]/70 via-transparent to-transparent" />

                <div className="absolute bottom-7 left-7 right-7">
                  <div className="rounded-2xl border border-white/20 bg-black/25 p-5 backdrop-blur-md">
                    <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#FF72AC]">
                      Groups • Teams • Companies
                    </p>

                    <p className="mt-2 font-serif text-2xl font-bold text-white">
                      Experiences That Bring People Together
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          HOTEL BOOKINGS
      ===================================================== */}
      <section className="bg-white py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-10">
          <div className="grid overflow-hidden rounded-[2.5rem] bg-[#FFF9F5] shadow-xl lg:grid-cols-2">
            <div className="relative min-h-[480px]">
              <img
                src={images.hotel}
                alt="Hotel accommodation"
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-[#17151A]/70 via-transparent to-transparent" />
            </div>

            <div className="flex items-center p-8 sm:p-12 lg:p-16">
              <div>
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#EC1676]/10">
                  <CalendarCheck
                    size={23}
                    className="text-[#EC1676]"
                  />
                </div>

                <span className="mt-7 block text-xs font-bold uppercase tracking-[0.25em] text-[#EC1676]">
                  Accommodation
                </span>

                <h2 className="mt-3 font-serif text-4xl font-bold leading-tight sm:text-5xl">
                  Stay Somewhere
                  <span className="text-[#EC1676]">
                    {" "}
                    You Love.
                  </span>
                </h2>

                <p className="mt-6 text-base leading-8 text-gray-600">
                  We can help arrange accommodation for your safari, business
                  trip, family holiday, beach escape, student journey or group
                  adventure.
                </p>

                <div className="mt-7 grid gap-3 sm:grid-cols-2">
                  {[
                    "Hotels",
                    "Safari lodges",
                    "Safari camps",
                    "Beach resorts",
                    "City accommodation",
                    "Group accommodation",
                  ].map((item) => (
                    <div
                      key={item}
                      className="flex items-center gap-2 rounded-xl bg-white px-4 py-3 text-sm font-semibold"
                    >
                      <Check
                        size={15}
                        className="text-[#EC1676]"
                      />
                      {item}
                    </div>
                  ))}
                </div>

                <a
                  href="/contact"
                  className="mt-8 inline-flex items-center gap-3 rounded-full bg-[#EC1676] px-7 py-4 text-sm font-bold text-white transition hover:-translate-y-1 hover:bg-[#D80F68]"
                >
                  Ask About Accommodation
                  <ArrowRight size={17} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          WHY WINCATE
      ===================================================== */}
      <section className="bg-white py-20 sm:py-24 lg:py-28">
        <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-10">
          <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:items-end">
            <div>
              <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#EC1676]">
                The Wincate Difference
              </span>

              <h2 className="mt-4 font-serif text-4xl font-bold leading-tight sm:text-5xl">
                Travel With
                <br />
                <span className="text-[#EC1676]">
                  Confidence.
                </span>
              </h2>
            </div>

            <p className="max-w-2xl text-base leading-8 text-gray-600">
              We believe good travel service is about being available,
              dependable and attentive to the details that matter — from
              planning and documentation to accommodation, transport and
              experiences.
            </p>
          </div>

          <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {benefits.map((benefit) => (
              <div
                key={benefit.number}
                className="group rounded-[1.75rem] border border-gray-100 bg-[#FFF9F5] p-7 transition duration-300 hover:-translate-y-2 hover:border-[#EC1676]/30 hover:shadow-xl"
              >
                <span className="text-xs font-black text-[#EC1676]">
                  {benefit.number}
                </span>

                <div className="mt-5 flex h-12 w-12 items-center justify-center rounded-2xl bg-[#EC1676]/10">
                  <ShieldCheck
                    size={22}
                    className="text-[#EC1676]"
                  />
                </div>

                <h3 className="mt-7 font-serif text-xl font-bold">
                  {benefit.title}
                </h3>

                <p className="mt-4 text-sm leading-7 text-gray-600">
                  {benefit.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =====================================================
          HOW IT WORKS
      ===================================================== */}
      <section className="bg-[#FFF9F5] py-20 sm:py-24">
        <div className="mx-auto max-w-6xl px-6 sm:px-8">
          <div className="mx-auto max-w-3xl text-center">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#EC1676]">
              Simple & Easy
            </span>

            <h2 className="mt-4 font-serif text-4xl font-bold sm:text-5xl">
              From Enquiry to Journey
            </h2>

            <p className="mt-5 text-base leading-7 text-gray-600">
              Tell us what you need and we will help organize the essential
              parts of your travel.
            </p>
          </div>

          <div className="mt-14 grid gap-8 md:grid-cols-3">
            {process.map((step) => (
              <div
                key={step.number}
                className="relative rounded-[2rem] bg-white p-8 shadow-sm transition duration-300 hover:-translate-y-2 hover:shadow-xl"
              >
                <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#EC1676] font-black text-white">
                  {step.number}
                </div>

                <h3 className="mt-7 font-serif text-2xl font-bold">
                  {step.title}
                </h3>

                <p className="mt-4 text-sm leading-7 text-gray-600">
                  {step.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =====================================================
          FINAL CTA
      ===================================================== */}
      <section className="relative overflow-hidden bg-[#EC1676] py-20 sm:py-24">
        <div className="absolute -right-32 -top-32 h-80 w-80 rounded-full border-[60px] border-white/10" />
        <div className="absolute -bottom-40 -left-32 h-96 w-96 rounded-full border-[70px] border-white/10" />

        <div className="relative mx-auto max-w-5xl px-6 text-center sm:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-white/70">
            Let's Plan Together
          </span>

          <h2 className="mt-4 font-serif text-4xl font-bold leading-tight text-white sm:text-5xl lg:text-6xl">
            Where Will Your Journey Take You?
          </h2>

          <p className="mx-auto mt-6 max-w-2xl text-base leading-8 text-white/85 sm:text-lg">
            Whether you need a safari, flight ticket, visa guidance, passport
            support, hotel booking, student travel, airport transfer, car
            hire or international holiday, Wincate is ready to help.
          </p>

          <div className="mt-9 flex flex-col justify-center gap-4 sm:flex-row">
            <a
              href="/contact"
              className="inline-flex items-center justify-center gap-3 rounded-full bg-[#17151A] px-8 py-4 text-sm font-bold text-white transition hover:-translate-y-1 hover:bg-black hover:shadow-2xl"
            >
              Plan Your Trip
              <ArrowRight size={17} />
            </a>

            <a
              href="https://wa.me/254724938419"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-3 rounded-full bg-white px-8 py-4 text-sm font-bold text-[#17151A] transition hover:-translate-y-1 hover:shadow-2xl"
            >
              <MessageCircle size={18} />
              WhatsApp Us
            </a>
          </div>

          <div className="mt-7 flex items-center justify-center gap-2 text-sm text-white/80">
            <Phone size={15} />
            <span>0724 938419</span>
          </div>
        </div>
      </section>

  
<footer className="bg-black text-white">
  {/* Footer Main */}
  <div className="mx-auto max-w-7xl px-6 py-14 lg:px-8">
    <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">

      {/* Brand */}
      <div>
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#EC1676] shadow-lg shadow-[#EC1676]/20">
            <span className="font-serif text-xl font-bold text-white">
              W
            </span>
          </div>

          <div>
            <h3 className="font-serif text-2xl font-bold">
              Wincate
            </h3>

            <p className="-mt-1 text-[10px] font-semibold uppercase tracking-[0.25em] text-[#FF4C9A]">
              Tours & Travels
            </p>
          </div>
        </div>

        <p className="mt-6 max-w-sm text-sm leading-7 text-white/55">
          Discover Kenya through unforgettable safaris, carefully planned
          tours, comfortable travel and experiences designed around your
          journey.
        </p>

        {/* =====================================================
            ANIMATED SOCIAL ICONS
        ===================================================== */}
        <div className="mt-7 flex gap-3">

          {/* Facebook */}
          <a
            href="https://www.facebook.com/WincateToursAndTravels"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
            className="group flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-white/[0.03] text-white/60 transition-all duration-300 hover:-translate-y-2 hover:rotate-3 hover:border-[#1877F2] hover:bg-[#1877F2] hover:text-white hover:shadow-lg hover:shadow-[#1877F2]/30"
          >
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              className="h-5 w-5 transition-transform duration-300 group-hover:scale-110"
            >
              <path d="M14 8h3V4h-3c-3.31 0-5 1.69-5 5v3H6v4h3v8h4v-8h3.5l.5-4H13V9c0-.67.33-1 1-1Z" />
            </svg>
          </a>
          {/* TikTok */}
          <a
         href="https://www.Tiktok.com/WincateToursAndTravels"
    target="_blank"
    rel="noreferrer"
    aria-label="TikTok"
    className="group flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-white/[0.03] text-white/60 transition-all duration-300 hover:-translate-y-2 hover:rotate-3 hover:border-[#FF0050] hover:bg-black hover:text-white hover:shadow-lg hover:shadow-[#FF0050]/30"
  >
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className="h-5 w-5 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6"
    >
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-3.88V2h-3.54v13.5a2.91 2.91 0 1 1-2-2.76v-3.6a6.45 6.45 0 1 0 5.54 6.36V8.67a8.3 8.3 0 0 0 4.86 1.56V6.69h-1.09Z" />
    </svg>
  </a>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/WincateToursAndTravels"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
            className="group flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-white/[0.03] text-white/60 transition-all duration-300 hover:-translate-y-2 hover:-rotate-3 hover:border-[#E4405F] hover:bg-gradient-to-br hover:from-[#833AB4] hover:via-[#E4405F] hover:to-[#FCAF45] hover:text-white hover:shadow-lg hover:shadow-[#E4405F]/30"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              className="h-5 w-5 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6"
            >
              <rect
                x="3"
                y="3"
                width="18"
                height="18"
                rx="5"
              />

              <circle
                cx="12"
                cy="12"
                r="4"
              />

              <circle
                cx="17.5"
                cy="6.5"
                r="1"
                fill="currentColor"
                stroke="none"
              />
            </svg>
          </a>

          {/* WhatsApp */}
          <a
            href="https://wa.me/254724938419"
            target="_blank"
            rel="noreferrer"
            aria-label="WhatsApp"
            className="group flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-white/[0.03] text-white/60 transition-all duration-300 hover:-translate-y-2 hover:rotate-3 hover:border-[#25D366] hover:bg-[#25D366] hover:text-white hover:shadow-lg hover:shadow-[#25D366]/30"
          >
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              className="h-5 w-5 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6"
            >
              <path d="M20.52 3.48A11.78 11.78 0 0 0 12.03 0C5.53 0 .24 5.29.24 11.79c0 2.08.54 4.11 1.56 5.9L.17 24l6.46-1.69a11.76 11.76 0 0 0 5.4 1.3h.01c6.49 0 11.78-5.29 11.78-11.79 0-3.14-1.22-6.1-3.3-8.34ZM12.04 21.6h-.01a9.78 9.78 0 0 1-4.98-1.36l-.36-.21-3.84 1 1.03-3.74-.24-.38a9.78 9.78 0 1 1 8.4 4.69Zm5.36-7.33c-.29-.15-1.72-.85-1.99-.94-.27-.1-.46-.15-.66.15-.19.29-.75.94-.92 1.13-.17.19-.34.22-.63.07-.29-.15-1.22-.45-2.32-1.44-.86-.77-1.44-1.72-1.61-2.01-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.15-.66-1.59-.9-2.18-.24-.57-.48-.49-.66-.5h-.56c-.19 0-.51.07-.78.36-.27.29-1.02 1-1.02 2.43s1.04 2.82 1.19 3.02c.15.19 2.05 3.13 4.96 4.39.69.3 1.23.48 1.65.61.69.22 1.32.19 1.82.12.55-.08 1.72-.7 1.96-1.37.24-.68.24-1.26.17-1.38-.07-.12-.26-.19-.55-.34Z" />
            </svg>
          </a>



        </div>

        {/* Small animated line */}
        <div className="mt-6 flex items-center gap-3">
          <span className="h-px w-10 bg-[#EC1676]" />

          <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-white/30">
            Follow Wincate
          </span>
        </div>
      </div>

      {/* =====================================================
          QUICK LINKS
      ===================================================== */}
      <div>
        <h4 className="mb-6 text-sm font-bold uppercase tracking-[0.2em] text-white">
          Explore
        </h4>

        <ul className="space-y-4 text-sm text-white/55">
          <li>
            <a
              href="/"
              className="group flex items-center gap-2 transition hover:text-[#FF4C9A]"
            >
              <span className="h-px w-0 bg-[#FF4C9A] transition-all duration-300 group-hover:w-4" />
              Home
            </a>
          </li>

          <li>
            <a
              href="/about"
              className="group flex items-center gap-2 transition hover:text-[#FF4C9A]"
            >
              <span className="h-px w-0 bg-[#FF4C9A] transition-all duration-300 group-hover:w-4" />
              About Us
            </a>
          </li>

          <li>
            <a
              href="/services"
              className="group flex items-center gap-2 transition hover:text-[#FF4C9A]"
            >
              <span className="h-px w-0 bg-[#FF4C9A] transition-all duration-300 group-hover:w-4" />
              Services
            </a>
          </li>

          <li>
            <a
              href="/packages"
              className="group flex items-center gap-2 transition hover:text-[#FF4C9A]"
            >
              <span className="h-px w-0 bg-[#FF4C9A] transition-all duration-300 group-hover:w-4" />
              Safari Packages
            </a>
          </li>

          <li>
            <a
              href="/contact"
              className="group flex items-center gap-2 transition hover:text-[#FF4C9A]"
            >
              <span className="h-px w-0 bg-[#FF4C9A] transition-all duration-300 group-hover:w-4" />
              Contact Us
            </a>
          </li>
        </ul>
      </div>

      {/* =====================================================
          DESTINATIONS
      ===================================================== */}
     
{/* =====================================================
    DESTINATIONS & SERVICES
===================================================== */}
<div>
  <h4 className="mb-6 text-sm font-bold uppercase tracking-[0.2em] text-white">
    Destinations & Services
  </h4>

  <ul className="space-y-4 text-sm text-white/55">
    <li>
      <a
        href="/Destinations"
        className="group flex items-center gap-2 transition hover:text-[#FF4C9A]"
      >
        <span className="h-px w-0 bg-[#FF4C9A] transition-all duration-300 group-hover:w-4" />
        Maasai Mara
      </a>
    </li>

    <li>
      <a
        href="/Destinations"
        className="group flex items-center gap-2 transition hover:text-[#FF4C9A]"
      >
        <span className="h-px w-0 bg-[#FF4C9A] transition-all duration-300 group-hover:w-4" />
        Amboseli
      </a>
    </li>

    <li>
      <a
        href="/Destinations"
        className="group flex items-center gap-2 transition hover:text-[#FF4C9A]"
      >
        <span className="h-px w-0 bg-[#FF4C9A] transition-all duration-300 group-hover:w-4" />
        Lake Nakuru
      </a>
    </li>

    <li>
      <a
        href="/Destinations"
        className="group flex items-center gap-2 transition hover:text-[#FF4C9A]"
      >
        <span className="h-px w-0 bg-[#FF4C9A] transition-all duration-300 group-hover:w-4" />
        Nairobi
      </a>
    </li>

    <li>
      <a
        href="/Destinations"
        className="group flex items-center gap-2 transition hover:text-[#FF4C9A]"
      >
        <span className="h-px w-0 bg-[#FF4C9A] transition-all duration-300 group-hover:w-4" />
        Diani Beach
      </a>
    </li>

    <li>
      <a
        href="/Destinations"
        className="group flex items-center gap-2 transition hover:text-[#FF4C9A]"
      >
        <span className="h-px w-0 bg-[#FF4C9A] transition-all duration-300 group-hover:w-4" />
        Dubai Holidays
      </a>
    </li>

    <li>
      <a
        href="/services"
        className="group flex items-center gap-2 transition hover:text-[#FF4C9A]"
      >
        <span className="h-px w-0 bg-[#FF4C9A] transition-all duration-300 group-hover:w-4" />
        Visa Assistance
      </a>
    </li>
  </ul>
</div>

      {/* =====================================================
          CONTACT
      ===================================================== */}
      <div>
        <h4 className="mb-6 text-sm font-bold uppercase tracking-[0.2em] text-white">
          Contact Us
        </h4>

        <div className="space-y-5 text-sm text-white/55">

          <div>
            <p className="mb-1 text-xs font-semibold uppercase tracking-wider text-[#FF4C9A]">
              Location
            </p>

            <p>
              9058-00300
              <br />
              Nairobi, Kenya
            </p>
          </div>

          <div>
            <p className="mb-1 text-xs font-semibold uppercase tracking-wider text-[#FF4C9A]">
              Phone
            </p>

            <a
              href="tel:0724938419"
              className="transition hover:text-[#FF4C9A]"
            >
              0724 938419
            </a>
          </div>
{/* Email */}
<div>
  <p className="mb-1 text-xs font-semibold uppercase tracking-wider text-[#FF4C9A]">
    Email
  </p>

  <a
    href="mailto:info@wincatetoursandtravels.com"
    className="break-all transition hover:text-[#FF4C9A]"
  >
    info@wincatetoursandtravels.com
  </a>
</div>
          <div>
            <p className="mb-1 text-xs font-semibold uppercase tracking-wider text-[#FF4C9A]">
              Website
            </p>

            <a
              href="https://wincatetoursandtravels.com"
              target="_blank"
              rel="noreferrer"
              className="break-all transition hover:text-[#FF4C9A]"
            >
              wincatetoursandtravels.com
            </a>
          </div>

        </div>
      </div>
    </div>

    {/* =====================================================
        BOTTOM BAR
    ===================================================== */}
    <div className="mt-12 flex flex-col gap-5 border-t border-white/10 pt-7 text-xs text-white/35 md:flex-row md:items-center md:justify-between">

      <p>
        © {new Date().getFullYear()} Wincate Tours & Travels. All rights reserved.
      </p>

      <div className="flex gap-5">
        <a
          href="/"
          className="transition hover:text-[#FF4C9A]"
        >
          Privacy Policy
        </a>

        <a
          href="/"
          className="transition hover:text-[#FF4C9A]"
        >
          Terms & Conditions
        </a>
      </div>

      <p>
        Kenya • Tours • Safaris • Travel
      </p>

    </div>
  </div>
</footer>
    </main>
  );
};

export default Services;